module.exports = __webpack_public_path__ + "static/elbleeding-4a3b41cf7b8ccae02174c0e09d9bcc13.gif";